import styles from './LinkButton.module.css';

interface Props{
    onClick:() => void;
    children:any;
}

export default function LinkButton({onClick, children}:Props) {
    return <span className={styles.text} onClick={onClick}>{children}</span>
}